var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{class:{'logo-img-fr': _vm.isLocaleFrench, 'logo-img-en': !_vm.isLocaleFrench },attrs:{"height":"75","width":"191","contain":"","src":_vm.isLocaleFrench},on:{"click":_vm.clickHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }